/**
 * R.H.I.E. AI Recommendation List
 * Kişiselleştirilmiş öneri listesi
 */

import React from 'react';
import { motion } from 'framer-motion';
import { Brain, ChevronRight, Sparkles } from 'lucide-react';
import { useRHIE } from './RHIEProvider';
import AIRecommendationCard from './AIRecommendationCard';

export default function AIRecommendationList({ 
  maxItems = 3,
  showHeader = true,
  compact = false,
  onViewAll,
  className = ''
}) {
  const { engine } = useRHIE();
  
  if (!engine) return null;
  
  const recommendations = engine.getRecommendations(maxItems);
  
  if (recommendations.length === 0) return null;
  
  return (
    <div className={className}>
      {showHeader && (
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-purple-500/20 flex items-center justify-center">
              <Brain className="w-4 h-4 text-purple-400" />
            </div>
            <div>
              <h3 className="text-white font-semibold text-sm">Sana Özel Öneriler</h3>
              <p className="text-white/40 text-xs">Geçmiş tercihlerine göre</p>
            </div>
          </div>
          
          {onViewAll && (
            <button
              onClick={onViewAll}
              className="text-purple-400 text-sm hover:text-purple-300 flex items-center gap-1 transition-colors"
            >
              Tümü
              <ChevronRight className="w-4 h-4" />
            </button>
          )}
        </div>
      )}
      
      <div className={compact ? 'space-y-2' : 'space-y-4'}>
        {recommendations.map((rec, index) => (
          <motion.div
            key={rec.session?.id || index}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
          >
            <AIRecommendationCard
              recommendation={rec}
              compact={compact}
              showReason={!compact}
            />
          </motion.div>
        ))}
      </div>
    </div>
  );
}
